import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V7C22 8.10457 21.1046 9 20 9V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V9C2.89543 9 2 8.10457 2 7V6ZM6 9V20H18V9H6ZM20 6H4V7H20V6Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 12C7 10.8954 7.89543 10 9 10H15C16.1046 10 17 10.8954 17 12V13C17 14.1046 16.1046 15 15 15H9C7.89543 15 7 14.1046 7 13V12ZM15 12H9V13H15V12Z",
		fill: "currentColor"
	})]
});
export default SvgArchive;
